import { useState } from "react";
import type { ValidationType } from "../../domain/request.types";

export interface WizardFormState {
  teamId: string;
  validationType: ValidationType | "";
  title: string;
  description: string;
  attachments: File[];
}

const emptyState: WizardFormState = {
  teamId: "",
  validationType: "",
  title: "",
  description: "",
  attachments: [],
};

export function useWizardState() {
  const [form, setForm] = useState<WizardFormState>(emptyState);

  function update<K extends keyof WizardFormState>(key: K, value: WizardFormState[K]) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  const isDetailsValid =
    form.teamId !== "" && form.validationType !== "" && form.title.trim().length > 0;

  return { form, update, isDetailsValid };
}
